import { Text } from '@oy/uidesktop';
import { formatCurrency } from 'src/utilities/helpers';
import styles from './DetailItem.module.css';

export const DetailItem = (props: {
  item: string;
  amount: string | number;
  bold?: boolean;
}) => {
  return (
    <Text
      textStyle={
        props.bold ? Text.Style.BodyMdSemibold : Text.Style.BodyMdRegular
      }
      className={styles.container}
    >
      <span>{props.item}</span>
      <span>{formatCurrency(props.amount)}</span>
    </Text>
  );
};
